import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Grid, Typography, Box, useMediaQuery, CircularProgress } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import SorryImg from '../../assets/images/Schedule-amico.png';
import NoData from '../../assets/images/NoData.png';

const LinkExpire = () => {
  const { id } = useParams();
  const location = useLocation();    
  const { ph } = location.state || {}; 

  const imgSrc = id === "timeout" ? SorryImg : NoData;

  const [loading, setLoading] = useState(true);
    const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Preload image and simulate load for text
  useEffect(() => {
    const img = new Image();
    img.src = imgSrc;
    img.onload = () => setLoading(false);
  }, [imgSrc]);

  if (loading) {
    // Full page loader
    return (
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ minHeight: '100vh', textAlign: 'center' }}
      >
        <CircularProgress />
      </Grid>
    );
  }

 

  // Main content
  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{
        minHeight: '70vh',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <Grid item xs={12} sm={10} md={6} lg={4}>
        {/* Responsive Image */}
        <Box
          component="img"
          src={imgSrc}
          alt="Expired Link"
          style={{
            width: '100%',
            maxWidth: 280,
            height: 'auto',
            margin: '0 auto 1.5rem auto',
            display: 'block',
          }}
        />

        {/* Text */}
        <Typography variant="body1" style={{ fontSize: '1.2rem', lineHeight: 1.75, textAlign: 'center'}}>
          {id === "timeout"
            ? "Appointment is past the timeline for action."
            : <>The window to <strong>{id}</strong> your appointment has closed. {!isMobile && <br />} 
                Please call us at <strong>{ph}</strong> for further assistance. {!isMobile && <br />}
                Thank you!</>
          }
        </Typography>
      </Grid>
    </Grid>
  );
};

export default LinkExpire;
